import React, { useState, useEffect } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardHeader,
  Container,
  makeStyles,
} from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import Page from "src/components/Page";
import BudgetRequisitionFormComponent from "src/components/forms/BudgetRequisitionFormComponent";
import PrintIcon from "@material-ui/icons/Print";
import PrintBudgetRequisitionModalComponent from "src/components/modals/PrintBudgetRequisitionModalComponent";
import { useSelector, useDispatch } from "react-redux";
import { getDepts } from "src/redux/actions/department.action";
import {
  getBudgetAdjProject,
  getBudgetAdjTo,
  updateBudgetAdj,
} from "src/redux/actions/budgetAdjustment.action";
import Moment from "moment";
import { isAllowed } from "src/utils/Auth";
import { getBuHead } from "src/redux/actions/getbuhead.action";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

export default function EditBudgetRequisitionComponent() {
  const classes = useStyles();

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const departmentReducer = useSelector((state) => state.departmentReducer);
  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  const { projects, budgets } = useSelector(
    (state) => state.budgetAdjustmentReducer
  );

  const {
    result: { secureid, perid, currency_code },
  } = useSelector((state) => state.loginReducer);
  const getbuheadReducer = useSelector((state) => state.getbuheadReducer);

  const [openPrint, setOpenPrint] = useState(false);

  useEffect(() => {
    dispatch(
      getDepts(
        location.state.COUNTRY_ID,
        location.state.COMPANY_ID,
        secureid,
        location.state.BRAND_ID
      )
    );
    dispatch(
      getBudgetAdjProject(
        location.state.COUNTRY_ID,
        location.state.COMPANY_ID,
        location.state.BRAND_ID,
        location.state.BUDGET_YEAR,
        location.state.DEPARTMENT_ID
      )
    );
    const [BG_TRAN_FROMs] = location.state.BG_TRAN_FROMs;
    dispatch(getBudgetAdjTo(BG_TRAN_FROMs.F_BUDGET_CODE));
    dispatch(getBuHead(perid));
    return () => {};
  }, []);

  return (
    <Page
      className={classes.root}
      title="Budget Requisition Form - Edit Investment Budget Transfer"
    >
      <Container maxWidth={false}>
        <Box mb={2}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              color="inherit"
              onClick={() => {
                history.replace("/budget-adjustment-requisition");
              }}
            >
              Budget Adjustment
            </Link>
            <Link color="textPrimary" aria-current="page">
              Budget Requisition Form (Edit)
            </Link>
          </Breadcrumbs>
        </Box>
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For budget adjustment on the system."
              title="Budget Requisition Form - Edit Investment Budget Transfer"
            />
          </Card>
        </Box>
        <Box mb={2}>
          {isAllowed(authorizePR.data, [
            "can_print_budget_adjustment_requisition",
          ]) && (
            <Button
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                setOpenPrint(true);
              }}
              disabled={Boolean(
                location.state.STATUS !== 3 ||
                  (location.state.ADJ_TYPE !== 2 &&
                    location.state.ADJ_TYPE !== 3)
              )}
            >
              <PrintIcon /> Print
            </Button>
          )}
        </Box>
        <Box mb={2}>
          <BudgetRequisitionFormComponent
            formType={"EDIT"}
            departmentTo={departmentReducer.result}
            projectsTo={projects.data}
            budgetsTo={budgets.data}
            ReasonLog={location.state.BG_TRAN_REASON_LOGs}
            formValue={{
              ...[...location.state.BG_TRAN_TOs][0],
              ...[...location.state.BG_TRAN_FROMs][0],
              ID: location.state.ID,
              DOCUMENT_NO: location.state.DOCUMENT_NO,
              BUDGET_YEAR: location.state.BUDGET_YEAR,
              STATUS: location.state.STATUS,
              STATUS_DESC: location.state.STATUS_DESC,
              BUDGET_TYPE: location.state.BUDGET_TYPE, // 1 = Investment , 0 = Expense
              COUNTRY_CODE: location.state.COUNTRY_CODE,
              BRAND_CODE: location.state.BRAND_CODE,
              BUDGET_TYPE_DESC: location.state.BUDGET_TYPE_DESC,
              ADJ_TYPE: location.state.ADJ_TYPE,
              REQUESTED_BY_ID: location.state.REQUESTED_BY_ID,
              REQUESTED_BY_NAME: location.state.REQUESTED_BY_NAME,
              REQUESTED_BY_EMAIL: location.state.REQUESTED_BY_EMAIL,
              REQUESTED_BRAND: location.state.REQUESTED_BRAND,
              REQUESTED_DEPARTMENT: location.state.REQUESTED_DEPARTMENT,
              REQUESTED_BRAND_NAME: location.state.REQUESTED_BRAND_NAME,
              REQUESTED_DEPARTMENT_NAME:
                location.state.REQUESTED_DEPARTMENT_NAME,
              REVIEWED_BY_ID: location.state.REVIEWED_BY_ID,
              REVIEWED_BY_NAME: location.state.REVIEWED_BY_NAME,
              REVIEWED_BY_EMAIL: location.state.REVIEWED_BY_EMAIL,
              REVIEWED_AT: location.state.REVIEWED_AT,
              VERIFIED_BY_ID: location.state.VERIFIED_BY_ID,
              VERIFIED_BY_NAME: location.state.VERIFIED_BY_NAME,
              VERIFIED_AT: location.state.VERIFIED_AT,
              CURRENCY_ID: location.state.CURRENCY_ID,
              CURRENCY_CODE: location.state.CURRENCY_CODE,
              COUNTRY_ID: location.state.COUNTRY_ID,
              COUNTRY_NAME: location.state.COUNTRY_NAME,
              COMPANY_ID: location.state.COMPANY_ID,
              COMPANY_NAME: location.state.COMPANY_NAME,
              BRAND_NAME: location.state.BRAND_NAME,
              BRAND_ID: location.state.BRAND_ID,
              DEPARTMENT_ID: location.state.DEPARTMENT_ID,
              DEPARTMENT_NAME: location.state.DEPARTMENT_NAME,
              AMOUNT: location.state.AMOUNT,
              REASON_ADJUSTMENT: location.state.REASON_ADJUSTMENT,
              REASON: "",
            }}
            onSubmit={(value) => {
              if (value.STATUS === 1 || value.STATUS === 2) {
                const [approval] = getbuheadReducer.result;
                if (approval) {
                  value.REVIEWED_BY_ID = approval.PER_ID;
                  value.REVIEWED_BY_NAME = approval.FULLNAME;
                  value.REVIEWED_BY_EMAIL = approval.PER_EMAIL;
                  dispatch(updateBudgetAdj(value, history));
                } else {
                  Swal.fire(
                    "The system message.",
                    "Your reviewer has not found!",
                    "warning"
                  );
                }
              } else {
                dispatch(updateBudgetAdj(value, history));
              }
            }}
          />
        </Box>
        <PrintBudgetRequisitionModalComponent
          open={openPrint}
          data={{
            CURRENCY_CODE: currency_code,
            DOCUMENT_NO: location.state.DOCUMENT_NO,
            REQUESTED_AT: Moment(location.state.REQUESTED_AT).format(
              "DD-MMM-YYYY"
            ),
            REQUESTED_BY_NAME: location.state.REQUESTED_BY_NAME,
            REQUESTED_BRAND_NAME: location.state.REQUESTED_BRAND_NAME,
            REQUESTED_DEPARTMENT_NAME: location.state.REQUESTED_DEPARTMENT_NAME,
            BUDGET_YEAR: location.state.BUDGET_YEAR,
            BUDGET_TYPE_DESC: location.state.BUDGET_TYPE_DESC,
            ADJ_TYPE_DESC: location.state.ADJ_TYPE_DESC,
            ...[...location.state.BG_TRAN_TOs][0],
            ...[...location.state.BG_TRAN_FROMs][0],
            AMOUNT: location.state.AMOUNT,
            REASON_ADJUSTMENT: location.state.REASON_ADJUSTMENT,
            REVIEWED_BY_ID: location.state.REVIEWED_BY_ID,
            REVIEWED_BY_NAME: location.state.REVIEWED_BY_NAME,
            REVIEWED_AT: Moment(location.state.REVIEWED_AT).format(
              "DD-MMM-YYYY"
            ),
            VERIFIED_BY_ID: location.state.VERIFIED_BY_ID,
            VERIFIED_BY_NAME: location.state.VERIFIED_BY_NAME
              ? location.state.VERIFIED_BY_NAME
              : "  ",
            VERIFIED_AT: location.state.VERIFIED_AT
              ? Moment(location.state.VERIFIED_AT).format("DD-MMM-YYYY")
              : "  ",
          }}
          handleClose={() => setOpenPrint(false)}
        />
      </Container>
    </Page>
  );
}
